import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { lazy } from 'react';

const EmailChange = lazy(() => import('components/email-change'));
const VerificationPage = lazy(() => import('components/verification-page'));
const RapnetVerifyEmail = lazy(() => import('components/rapnet-verify-email'));

export const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<EmailChange />} />
        <Route path="/verify" element={<VerificationPage />} />
        <Route path="/verifyemail" element={<RapnetVerifyEmail />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
